import React, {useEffect} from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import DossierPage from "./DossierPage";
import DossierGestionPage from "./DossierGestionPage";
import {useHeader} from "../../contexts/HeaderContext";

const DossierWrapper = () => {
  const {setTitle} = useHeader();

  useEffect(() => {
    setTitle("Gestion des dossiers");
  }, [setTitle]);

  return (
    <Routes>
      <Route path='' element={<DossierPage/>}/>
      <Route path='/gerer/:id' element={<DossierGestionPage/>}/>

      <Route path='*' element={<Navigate to='/404' replace/>}/>
    </Routes>
  )
}

export {DossierWrapper}